import { NetworkResourceCenter } from '.generated/templates/Project.NetworkResourceCenter.model';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import { useCallback, useState } from 'react';
import CheckoutSteps, { CheckoutStepsItems } from './Components/CheckoutSteps';
import OrderSummary from './Components/OrderSummary';
import CheckoutReview from './Components/CheckoutReview';
import ShippingAddress from './Components/ShippingAddress';
import ShippingMethod from './Components/ShippingMethod';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import classnames from 'classnames';
import Loading from 'components/helpers/SvgIcon/icons/loading';
import MailOrder, { OrderDataProps } from './Components/MailOrder';

export type SecureCheckoutProps = NetworkResourceCenter.Checkout.Fields.NrcCheckout;

const SecureCheckout = ({ fields }: SecureCheckoutProps) => {
  const [activeStep, setActiveSteps] = useState<number>(0);
  const [customerData, setCustomerData] = useState<OrderDataProps>();
  const checkoutSteps: CheckoutStepsItems[] = [
    { name: fields?.shippingAddressLabel.value, value: 1 },
    { name: fields?.shippingMethodLabel.value, value: 2 },
    { name: fields?.reviewLabel.value, value: 3 },
  ];
  const updateSteps = useCallback((value: number) => {
    setActiveSteps(value);
  }, []);

  // Fail out if we don't have any fields
  if (!fields) {
    return <MissingDataSource />;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const updateCustomerData = (orderData: OrderDataProps) => {
    const updatedOrderData = { ...orderData, EmailItemId: fields?.orderEmail?.id };
    setCustomerData(updatedOrderData);
  };

  const ifOrderAvailable =
    customerData !== undefined &&
    customerData.OrderedProducts !== undefined &&
    customerData.OrderedProducts.length > 0;

  return (
    <div
      data-component="authorable/NetworkResourceCenter/securecheckout"
      className={classnames('secure-checkout')}
    >
      <div className={classnames()}>
        <Text
          field={fields.checkoutLabel}
          tag="h1"
          className={classnames('heading-xl-extendable font-medium')}
        />
      </div>
      <div className={classnames('flex', 'flex-col-reverse', 'md:flex-row')}>
        <div className={classnames('w-full', 'md:w-2/3')}>
          <div className={classnames('hidden', 'pb-6', 'pt-8', 'mb-10', 'md:block')}>
            <CheckoutSteps active={activeStep} allSteps={checkoutSteps} />
          </div>
          <div>
            {activeStep === 0 && <ShippingAddress {...fields} updateSteps={updateSteps} />}
            {activeStep === 1 && <ShippingMethod {...fields} updateSteps={updateSteps} />}
            {activeStep === 2 && (
              <CheckoutReview
                {...fields}
                updateSteps={updateSteps}
                updateCustomerData={updateCustomerData}
              />
            )}
            {activeStep === 3 && ifOrderAvailable && (
              <>
                <div className={classnames('flex', 'flex-col', 'items-center', 'md:w-4/5')}>
                  <div className={classnames('pb-4', 'text-m', 'text-solidBlack')}>
                    Sending Request...
                  </div>
                  <Loading />
                  <MailOrder {...customerData} />
                </div>
              </>
            )}
          </div>
        </div>
        <div className={classnames('w-full', 'md:w-1/3')}>
          <OrderSummary />
        </div>
      </div>
    </div>
  );
};

export default SecureCheckout;
